// extracted by mini-css-extract-plugin
export default {"cardList":"index_cardList__9pebd","item":"index_item__xNcmO","list":"index_list__hTH79","numWrap":"index_numWrap__naj3r","num":"index_num__OxErq","label":"index_label__bM8fh"};